import { IStipoProcesso, TipoProcesso } from "../tipoProcesso/TipoProcesso";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { Documento } from "./Documento";

export interface Processo {
    id: string;
    numeroProcesso: string | null;
    especificacao: string | null;
    observacao: string | null;
    nivelAcesso: "SIGILOSO" | "RESTRITO" | "PUBLICO";
    ativo: boolean;
    usuario: UsuarioList;
    tipoProcesso: TipoProcesso;
    dataHoraCriacao: Date | null;
    dataHoraAtualizacao: Date | null;
    documentos: Documento[];
    favorito: boolean;
    deuCiencia: boolean;

}

export const ISprocesso: Processo = {
    id: "",
    tipoProcesso: IStipoProcesso,
    numeroProcesso: "",
    dataHoraCriacao: null,
    dataHoraAtualizacao: null,
    especificacao: "",
    observacao: "",
    nivelAcesso: "RESTRITO",
    ativo: true,
    usuario: ISusuarioList,
    documentos: [],
    favorito: false,
    deuCiencia: false,
}